var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSearchBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9576 11.0171L15.8041 14.8637C16.0653 15.1216 16.0653 15.5461 15.8041 15.8041C15.5429 16.0653 15.1216 16.0653 14.8604 15.8041L11.0139 11.9608C9.85143 12.9143 8.36571 13.4857 6.74286 13.4857C3.01714 13.4857 0 10.4653 0 6.74286C0 3.02041 3.01714 0 6.74286 0C10.4653 0 13.4857 3.02041 13.4857 6.74286C13.4857 8.36571 12.911 9.85469 11.9576 11.0171ZM1.33878 6.74286C1.33878 9.72082 3.76163 12.1437 6.74286 12.1437C9.72082 12.1437 12.1469 9.72082 12.1469 6.74286C12.1469 3.7649 9.72082 1.33878 6.74286 1.33878C3.76163 1.33878 1.33878 3.7649 1.33878 6.74286Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchBlack);
export default __webpack_public_path__ + "static/media/ic_search_black.34ab47f79f1b1c9e7feaab18fb43888e.svg";
export { ForwardRef as ReactComponent };